const randomNumber = function(number, offset = 0) {
  return Math.floor(Math.random() * number) - offset
}

export default randomNumber
